import StringUtil from "utils/string-util"
import TimeUtil from "utils/time-util"

const FinancePaymentsUrlParamsTableCellService = {
  /**
   * Generate cell content for FinancePaymentsUrlParamsTable
   * @param {object} payment - Payment data
   */
  generatePaymentCellData: (payment) => ({
    'id': {
      content: payment.id
    },
    'payments.created_at': {
      content: TimeUtil.format(payment.created_at, 'DD MMM YY, HH:mm:ss')
    },
    'payments.paid_at': {
      content: payment.paid_at ? TimeUtil.format(payment.paid_at, 'DD MMM YY, HH:mm:ss') : "-"
    },
    'payments.reference_number': {
      content: payment.reference_number
    },
    'deals.reference_number': {
      content: payment.deal.reference_number
    },
    'users.email': {
      content: payment.user.email
    },
    'user_details.name': {
      content: payment.user.detail.name
    },
    'deals.final_payment': {
      content: StringUtil.currencyCase(payment.deal.final_payment)
    },
    'deals.total_quantity': {
      content: payment.deal.total_quantity ?? '-'
    },
    'deals.down_payment': {
      content: payment.deal.down_payment ? StringUtil.currencyCase(payment.deal.down_payment) : "-"
    },
    'deals.state': {
      content: payment.deal.state
    },
  })

}

export default FinancePaymentsUrlParamsTableCellService
